import { getIsIssuesLoading } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/issues';
import { getTableItems } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/table';
import {
	getOnlyEnabledIssueId,
	getTimelineRange,
	getZoomLevel,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/timeline';
import {
	getDependencySettingsDisplay,
	getWarningViewSettings,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/view-settings';
import { getShowSprints } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/visualisations';
import { getWarnings } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/warnings';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import { createStructuredSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';
import type { Props, StateProps } from './types';

export default createStructuredSelector<State, Props, StateProps>({
	dependencySettingsDisplay: getDependencySettingsDisplay,
	isLoading: getIsIssuesLoading,
	onlyEnabledIssueId: getOnlyEnabledIssueId,
	scope: getTableItems,
	showCapacity: getShowSprints,
	showWarning: (state) => getWarningViewSettings(state).showWarning,
	timelineRange: getTimelineRange,
	warnings: getWarnings,
	zoomLevel: getZoomLevel,
});
